var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWarning = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 72 72"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M37.8 38.937h-3.6v-7.579h3.6zm0 7.579h-3.6v-3.79h3.6zM16.2 52.2h39.6L36 16.2z"
})));
export default SvgWarning;